export const constant = (a) => (_) => a;
export function compose(g, ...gs) {
    return (x) => gs.reduce((y, h) => h(y), g(x));
}
// Category
export const id = (a) => a;
// Functor
export const map = (f, a) => compose(a, f);
// Profunctor
export const promap = (g, h, fn) => (a) => h(compose(g, fn)(a));
// Arrow
export const arr = (f) => f;
export const first = (f) => ([a, c,]) => [f(a), c];
export const second = (g) => ([c, a]) => [c, g(a)];
/// ***
export const split = (f, g) => ([a, c]) => [f(a), g(c)];
/// &&&
export const fanout = (f, g) => (a) => [f(a), g(a)];

